module.exports = __webpack_public_path__ + "img/add-image.d64e1b63.svg";